import { utils } from '@hh/global.js'

if (!customElements.get('deferred-media')) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super()
      this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
        'click',
        this.loadContent.bind(this)
      )
    }

    loadContent() {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div')
        content.appendChild(
          this.querySelector('template').content.firstElementChild.cloneNode(true)
        )

        this.setAttribute('loaded', true)

        utils.pauseAllMedia()

        const media = content.querySelector('video, model-viewer, iframe');
        this.appendChild(media);
        media.focus();
        media.muted = true;
        media.play().catch(e => {
          console.warn('Playback failed:', e);
        });

        if (media.tagName === 'VIDEO') {
          media.addEventListener('play', () => {
            const poster = this.querySelector('[id^="Deferred-Poster-"]');
            if (poster) poster.style.display = 'none';
          });
        }

        const toggleButton = this.querySelector('[id^="Deferred-Poster-"]');
        toggleButton.addEventListener('click', () => {
          media.muted = true;
          media.play().catch(e => {
            console.warn('Playback failed:', e);
          });
        });
      }
    }
  }

  customElements.define('deferred-media', DeferredMedia)
}

